var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgSelfCareToolkits = function SvgSelfCareToolkits(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M3.782 31.181H52v2.5H3.782v-2.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M28 26.827c.69 0 1.25.56 1.25 1.25v7.692a1.25 1.25 0 0 1-2.5 0v-7.692c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M6.846 17.788a2.596 2.596 0 0 0-2.596 2.596v26.924a2.596 2.596 0 0 0 2.596 2.596h42.308a2.596 2.596 0 0 0 2.596-2.596V20.384a2.596 2.596 0 0 0-2.596-2.596H6.846ZM1.75 20.384a5.096 5.096 0 0 1 5.096-5.096h42.308a5.096 5.096 0 0 1 5.096 5.096v26.924a5.096 5.096 0 0 1-5.096 5.096H6.846a5.096 5.096 0 0 1-5.096-5.096V20.384Z",
    clipRule: "evenodd"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M6.846 17.788a2.596 2.596 0 0 0-2.596 2.596v26.924a2.596 2.596 0 0 0 2.596 2.596h42.308a2.596 2.596 0 0 0 2.596-2.596V20.384a2.596 2.596 0 0 0-2.596-2.596H6.846ZM1.75 20.384a5.096 5.096 0 0 1 5.096-5.096h42.308a5.096 5.096 0 0 1 5.096 5.096v26.924a5.096 5.096 0 0 1-5.096 5.096H6.846a5.096 5.096 0 0 1-5.096-5.096V20.384Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M18.957 7.496a12.789 12.789 0 0 1 21.831 9.042 1.25 1.25 0 1 1-2.5 0 10.288 10.288 0 1 0-20.577 0 1.25 1.25 0 1 1-2.5 0c0-3.391 1.348-6.644 3.746-9.042Z",
    clipRule: "evenodd"
  }), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M18.957 7.496a12.789 12.789 0 0 1 21.831 9.042 1.25 1.25 0 1 1-2.5 0 10.288 10.288 0 1 0-20.577 0 1.25 1.25 0 1 1-2.5 0c0-3.391 1.348-6.644 3.746-9.042Z",
    clipRule: "evenodd"
  })));
};
export default SvgSelfCareToolkits;